import { render, staticRenderFns } from "./dshop.vue?vue&type=template&id=89925ee2&"
import script from "./dshop.vue?vue&type=script&lang=js&"
export * from "./dshop.vue?vue&type=script&lang=js&"
import style0 from "./dshop.vue?vue&type=style&index=0&id=89925ee2&prod&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DshopException: require('/app/components/dshop/Exception.vue').default,SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,DshopRender: require('/app/components/dshop/Render.vue').default})
